import { Fade, FormControlLabel, Grid, Paper, Popper, Switch, Typography } from "@mui/material"
import {Calendar, DateObject} from "react-multi-date-picker"
// import gregorian_es from "react-date-object/locales/gregorian_es"
import { useEffect, useState } from "react";

import "./index.css"
import BirthdaysCard, { BirthdayEmployeeCard } from "../../posts/BirthdaysCard";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../store";
import { getYearBirthdays } from "../../../store/slices/posts";

const gregorian_es = {
    name: "gregorian_es",
    months: [
      ["Enero", "Ene"],
      ["Febrero", "Feb"],
      ["Marzo", "Mar"],
      ["Abril", "Abr"],
      ["Mayo", "May"],
      ["Junio", "Jun"],
      ["Julio", "Jul"],
      ["Agosto", "Ago"],
      ["Septiembre", "Sep"],
      ["Octubre", "Oct"],
      ["Noviembre", "Nov"],
      ["Diciembre", "Dic"],
    ],
    weekDays: [
      ["Sábado", "Sab"],
      ["Domingo", "Dom"],
      ["Lunes", "Lun"],
      ["Martes", "Mar"],
      ["Miércoles", "Mie"],
      ["Jueves", "Jue"],
      ["Viernes", "Vie"],
    ],
    digits: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"],
    meridiems: [
      ["AM", "am"],
      ["PM", "pm"],
    ],
}

const BirthdayMonth = ({month=0}: {month?: number}) => {
    
    const {birthdaysData} = useSelector((state: RootState) => state.posts);
  
    const [values, setValues] = useState<Date[]>([]);
    const [monthSelected, setMonthSelected] = useState<number>(month);
    const [yearSelected, setYearSelected] = useState<number>(new Date().getFullYear());
    
    useEffect(() => {
        if (!birthdaysData?.data?.length) {
            setValues([]);
            return
        }
        const bitdays = birthdaysData.data
            .map(b => {
                const aniversary = new Date(b.Aniversario);
                aniversary.setFullYear(yearSelected);
                return aniversary
            });
        setValues(bitdays)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [birthdaysData])
    
    return (
        <Grid
            container
            direction="row"
            width="100%"
            // marginTop="1.5rem"
            margin="1.5rem 0 0 0"
            minHeight="60%"
            // columnSpacing="1.5rem"
            justifyContent="space-between"
        >
            <Grid item xs={12} sm={6} sx={{pr: {xs: 0, sm: "1.5rem"}}} style={{paddingLeft: "0rem"}}>

                <MyCalendar 
                    // multiple
                    value={values as any} 
                    birthdays={birthdaysData?.data as any}
                    disableYearPicker={true}
                    readOnly={true}
                    onMonthChange={(value: DateObject) => {
                        setMonthSelected(value.month.number);
                        setYearSelected(value.year)
                    }}
                />
            </Grid>
            <Grid item xs={12} sm={6} sx={{mt: {xs: "1.5rem", sm: 0}}}>
                <BirthdaysCard 
                    title="Próximas celebraciones"
                    hidenButton={true}
                    month={monthSelected}
                />
            </Grid>
        </Grid>
    )
}

interface GroupedBirthdays {
    [month: number]: Date[];
}

const BirthdayYear = () => {
    
    const dispatch = useDispatch<AppDispatch>();
    const {companyselected, sessionData, connectionId} = useSelector((state: RootState) => state.auth);
    const {birthdaysData} = useSelector((state: RootState) => state.posts);
  
    const [groupedBirthdays, setGroupedBirthdays] = useState<GroupedBirthdays>();
    const [yearSelected] = useState<number>(new Date().getFullYear());
    
    useEffect(() => {
        if (!birthdaysData?.data?.length) {
            setGroupedBirthdays({});
            return;
        }

        const groupedByMonth = birthdaysData.data.reduce((acc: any, b) => {
            const aniversary = new Date(b.Aniversario);
            aniversary.setFullYear(yearSelected);
            const month = aniversary.getMonth();

            if (!acc[month]) {
                acc[month] = [];
            }

            acc[month].push({
                ...b,
                name: b.Descripcion,
                // date: aniversary.toISOString().split("T")[0],
            });
            return acc;
        }, {});
        setGroupedBirthdays(groupedByMonth);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [birthdaysData]);

    
    useEffect(() => {
        if (!companyselected || !sessionData || !connectionId) return;
        console.log("getting birthdays")
        dispatch(getYearBirthdays(yearSelected))
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [connectionId])
    
    return (
        <Grid
            container
            direction="row"
            width="100%"
            // marginTop="1.5rem"
            margin="1.5rem 0 0 0"
            minHeight="60%"
            spacing="1rem"
            justifyContent="space-between"
            position="relative"
        >
            {groupedBirthdays && [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((month) => {
                const requiredDate = new DateObject().setMonth(month);
                const rmonth = requiredDate.month.number;
                const year = requiredDate.year;
                const startDate = new Date(year, rmonth - 1).setDate(1);
                const endDate = new Date(year, rmonth).setDate(-1);
                return (
                    <Grid item  xs={12} sm={6} md={3} lg={3} xl={3} key={month}>
                        <MyCalendar
                            className="calendar"
                            // multiple
                            currentDate={requiredDate}
                            minDate={startDate} // No permite seleccionar un mes anterior
                            maxDate={endDate}
                            // value={(groupedBirthdays[month - 1] || []) as any} 
                            disableYearPicker={true}
                            disableMonthPicker={true}
                            readOnly={true}
                            hideYear={true}
                            birthdays={(groupedBirthdays[month - 1] || []) as any}
                        />
                        {/* <Calendar 
                            className="calendar"
                            // multiple
                            currentDate={requiredDate}
                            minDate={startDate} // No permite seleccionar un mes anterior
                            maxDate={endDate}
                            value={(groupedBirthdays[month - 1] || []) as any} 
                            disableYearPicker={true}
                            disableMonthPicker={true}
                            readOnly={true}
                            hideYear={true}
                            // onMonthChange={(value: DateObject) => {
                            //     setMonthSelected(value.month.number);
                            //     setYearSelected(value.year)
                            // }}
                        /> */}
                    </Grid>
                );
            })}
        
        </Grid>
    )
}

interface BirthdayProps {
    name: string;
    date: string; // formateada como "YYYY-MM-DD"
}

const MyCalendar = ({birthdays, ...props}: any) => {
    const [anchorEl, setAnchorEl] = useState<HTMLDivElement | null>(null);
    const [selectedDate, setSelectedDate] = useState<Date | null>(null);
    const [open, setOpen] = useState(false);
    // const [placement, setPlacement] = useState<'left' | 'right' | 'bottom'>('bottom');
  
    const handleDateClick = (event: React.MouseEvent<HTMLDivElement>, date: DateObject) => {
        const hasBirthday = birthdays?.some((b: any) => someBirthday(date.toDate(), b));

        if (hasBirthday) {
            // const clickedElement = event.currentTarget.getBoundingClientRect();
            // const windowWidth = window.innerWidth;
            // if (clickedElement.left < windowWidth / 2) {
            //   setPlacement('right');
            // } else {
            //   setPlacement('left');
            // }
            
            setAnchorEl(event.currentTarget);
            setSelectedDate(date.toDate());
            setOpen(true);
        }
    };
  
    const handleClose = () => {
      setOpen(false);
    };

    const someBirthday = (date: Date, b: any) => {
        const aniversary = new Date(b.Aniversario);
        const month = aniversary.getMonth();
        const day = aniversary.getDate();
        const selectedMonth = date.getMonth();
        const selectedDay = date.getDate();
        const isValid = day === selectedDay && month === selectedMonth;
        return isValid;

    }
  
    const selectedBirthdays = birthdays?.filter((b: BirthdayProps) => selectedDate && someBirthday(selectedDate, b));

    return (
      <div>
        <Calendar
            locale={gregorian_es}
            {...props}
            mapDays={({ date }) => {
                const hasBirthday = birthdays?.some((b: any) => someBirthday(date.toDate(), b));
                if (hasBirthday) {
                    return {
                        className: "calendar-day",
                        // style: { backgroundColor: '#107B4F', color: 'white', cursor: 'pointer', borderRadius: "40px" },
                        onClick: (event: React.MouseEvent<HTMLDivElement>) => handleDateClick(event, date),
                        onMouseLeave: handleClose,
                        onMouseEnter: (event: React.MouseEvent<HTMLDivElement>) => handleDateClick(event, date),
                    };
                }
                return { className: "normal-day",};
                }}
        />
        <Popper
          open={open}
          anchorEl={anchorEl}
          placement="right-end"
          transition
          onMouseLeave={handleClose}
          modifiers={[
            {
              name: 'preventOverflow',
              options: {
                boundary: 'viewport',
                padding: 10,
              },
            },
          ]}
        >
          {({ TransitionProps }) => (
            <Fade {...TransitionProps} timeout={350}>
              <Paper elevation={3} style={{ padding: '10px' }}>
                {selectedBirthdays.length > 0 ? (
                  selectedBirthdays.map((birthday: BirthdayProps, index: number) => (
                    // <Typography key={index}>{birthday.name}</Typography>
                    <BirthdayEmployeeCard
                        key={index}
                        data={birthday}
                    />
                  ))
                ) : (
                  <Typography>No hay cumpleaños en esta fecha.</Typography>
                )}
              </Paper>
            </Fade>
          )}
        </Popper>
      </div>
    );
};

const Birthday = () => {
    
    const [viewType, setViewType] = useState<"month" | "year">("year");

    
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setViewType(event.target.checked ? "year" : "month");
  };
    
    return (
        <Grid container>
            <FormControlLabel 
                control={
                    <Switch 
                        checked={viewType === "year"}
                        onChange={handleChange}
                    />} 
                label={"Ver por año"}
            />
           {viewType === "month" 
                ? <BirthdayMonth month={new Date().getMonth() + 1} />
                : <BirthdayYear />
            }
        </Grid>
    )
}

export default Birthday;